var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclaim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5001 0C16.3001 0 20.9501 4.65 21.0501 10.5C21.0992 16.0558 16.6038 20.7414 11.0817 21.0387L10.8001 21.05H10.5501C8.37786 21.05 6.38403 20.381 4.69496 19.2537L4.40008 19.05L1.60008 20.45C1.55008 20.5 1.45008 20.5 1.40008 20.5C1.12508 20.5 0.892093 20.2479 0.97071 19.9748L1.00008 19.9L2.35008 17.1C0.700079 15.05 -0.199921 12.4 0.0500788 9.5C0.500079 4.55 4.50008 0.55 9.40008 0.05C9.80008 0 10.1501 0 10.5001 0ZM10.5001 15C9.95008 15 9.50008 15.45 9.50008 16C9.50008 16.55 9.95008 17 10.5001 17C11.0501 17 11.5001 16.55 11.5001 16C11.5001 15.45 11.0501 15 10.5001 15ZM10.0001 4.5C10.0001 4.2 10.2001 4 10.5001 4L10.5962 4.00727C10.8421 4.04568 11.0001 4.23333 11.0001 4.5V13.5C11.0001 13.8 10.8001 14 10.5001 14L10.4039 13.9927C10.1581 13.9543 10.0001 13.7667 10.0001 13.5V4.5Z",
    fill: "#582483"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclaim);
export default __webpack_public_path__ + "static/media/exclaim.f09c98b42e56cb77f40cca33d21970b8.svg";
export { ForwardRef as ReactComponent };